import { Component, inject, input, output } from '@angular/core';

import { Store } from '@ngrx/store';

import { Location } from '@era/locations-sdk';

import { CategoryStoreSelectors } from '@era/stores';
import { LocationSelectComponent } from './location-select.component';

@Component({
  selector: 'era-location-select',
  templateUrl: './location-select.container.html',
  imports: [LocationSelectComponent],
})
export class LocationSelectContainerComponent {
  private readonly store = inject(Store);

  readonly isEnabled = input(true);
  readonly location = input.required<Location>();
  readonly locationChange = output<Location>();

  public readonly locations = this.store.selectSignal(
    CategoryStoreSelectors.selectAllCategoryEntitiesByType('Location')
  );

  selected(location: Location) {
    this.locationChange.emit(location);
  }
}
